<template>
    <div class="aside">
        <police-aside v-if="item=='police'"></police-aside>
    </div>
</template>

<script>
import PoliceAside from './police-aside.vue'
export default {
    name: 'Aside',
    components: {
        PoliceAside, 
    },
    props: {
        item: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss" scoped>

</style>